import React, { useEffect, useState } from 'react';
import { ListItemProps } from '../../Handbooks.types';
import { Styled } from '../../Handbooks.styles';
import { useRouteMatch } from 'react-router';
import { IconButton } from 'office-ui-fabric-react';

export const ListItem: React.FC<ListItemProps> = (props: ListItemProps) => {
  const additionalInfo = props.config.makeAdditional(props.elem, props.connections)
  return (
    <Styled.ListItem key={`elem${props.elem[props.indexFieldName]}`} to={`/handbooks/${props.type}/${props.elem[props.indexFieldName]}`}>
      <Styled.ListItemIndex>{props.elem[props.indexFieldName]}</Styled.ListItemIndex>
      <Styled.ListItemTitle>{props.config.makeTitle(props.elem, props.connections)}</Styled.ListItemTitle>
      {additionalInfo &&
        <Styled.ListItemAdditional>{additionalInfo}</Styled.ListItemAdditional>}
    </Styled.ListItem>
  );
};